import { SeoPage, SeoReplaceValues } from 'libs/shared-lib/interfaces';
export const SUB_DEALER_SEO_DE: SeoPage = {
    title: `${SeoReplaceValues.DEALER_NAME}: Wir über uns`,
    description: '',
    image: '',
    twitter: {
        card: 'summary',
        title: `${SeoReplaceValues.DEALER_NAME}: Wir über uns`,
        description: '',
    },
    og: {
        title: `${SeoReplaceValues.DEALER_NAME}: Wir über uns`,
        description: '',
    },
    robots: {
        noIndex: false,
        noFollow: false,
    },
};
